export default __webpack_public_path__ + "static/sample-data-installed-c148e472d9243538a307abb1894b410c.png";